import React, { useState } from "react";
import CustomTable from "../../../components/Tables/CustomTable";
import WhiteTitledCard from "../../../components/cards/WhiteTitledCard";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../redux/app/hooks";
import { setSelectedUser } from "../../../redux/features/adminSlice";
import ClickableUserName from "../../../components/shared/ClickableUserName";

const SummaryTable: React.FC = () => {
  const [currentTab, setCurrentTab] = useState(1);
  const { vendors, isLoading: vendorsLoading } = useAppSelector(
    (state) => state.admin,
  );
  const { buyers, isLoading: buyersLoading } = useAppSelector(
    (state) => state.admin,
  );
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const columns = [
    { label: "S/N", field: "id" },
    { label: "Name of Vendor", field: "vendor_name" },
    { label: "Username", field: "username" },
    { label: "Phone Number", field: "phone_number" },
    { label: "Email", field: "email" },
    { label: "Country", field: "country" },
  ];

  const tabList = [
    { id: 1, name: "Vendors", count: vendors?.data?.totalItems ?? 0 },
    { id: 2, name: "Buyers", count: buyers?.data?.totalItems ?? 0 },
  ];

  const vendorData = vendors?.data?.data?.map((vendor: any, index: number) => {
    return {
      _user: vendor,
      id: index + 1,
      vendor_name: <ClickableUserName user={vendor} userType="VENDOR" />,
      username: vendor?.username ?? "N/A",
      phone_number: vendor?.phoneNumber ?? "N/A",
      country:
        (typeof vendor?.country === "string"
          ? vendor?.country
          : vendor?.country?.name) ?? "N/A",
      email: vendor?.email ?? "N/A",
    };
  });

  const buyersData = buyers?.data?.data?.map((buyer: any, index: number) => {
    return {
      _user: buyer,
      id: index + 1,
      vendor_name: <ClickableUserName user={buyer} userType="BUYER" />,
      username: buyer?.username ?? "N/A",
      phone_number: buyer?.phoneNumber ?? "N/A",
      country:
        (typeof buyer?.country === "string"
          ? buyer?.country
          : buyer?.country?.name) ?? "N/A",
      email: buyer?.email ?? "N/A",
    };
  });

  return (
    <WhiteTitledCard>
      <div className="px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between w-full gap-3 sm:gap-0">
          {/* Tab List */}
          <div className="flex flex-wrap items-center gap-3 sm:gap-4">
            {tabList?.map((tab) => (
              <div
                key={tab.id}
                className={`space-x-2 cursor-pointer text-sm font-semibold p-2 ${
                  currentTab === tab.id
                    ? "text-black border-b-2 border-primary"
                    : "text-gray-500"
                }`}
                onClick={() => setCurrentTab(tab.id)}
              >
                <span>{tab.name}</span>
                <span className="bg-lightPurple px-2 text-accent rounded-md">
                  {tab?.count}
                </span>
              </div>
            ))}
          </div>

          {/* View All Button */}
          <div className="flex items-center">
            <span
              className="text-accent cursor-pointer text-sm sm:text-md w-fit sm:w-[100px]"
              onClick={() => {
                currentTab === 1
                  ? navigate("/user-management/vendor")
                  : navigate("/user-management/buyer");
              }}
            >
              View All
            </span>
          </div>
        </div>

        <CustomTable
          data={{ columns, rows: currentTab === 1 ? vendorData : buyersData }}
          onRowClick={(row) => {
            dispatch(setSelectedUser(row._user));
            if (currentTab === 1) {
              navigate(`/user-management/vendor/${row._user?.id}`);
            } else {
              navigate(`/user-management/buyer/${row._user?.id}`);
            }
          }}
          showFooter={false}
          loading={currentTab === 1 ? vendorsLoading : buyersLoading}
        />
      </div>
    </WhiteTitledCard>
  );
};

export default SummaryTable;
